export default "__VITE_ASSET__DaxCiJ14__"